/* Language */
const languageDE: string = 'de';
const languageEN: string = 'en';
const languageES: string = 'es';

const languageDefault: string = languageDE;

const languageFallback: string = languageEN;

/*
 * Export functions.
 */
export {
    languageDE,
    languageEN,
    languageES,
    languageDefault,
    languageFallback
}
